import { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import CardSeplag from "./../../components/CardSeplag/index";
import TableSeplag from "../../components/TableSeplag";
import RotuloSeplag from "../../components/RotuloSeplag";
import ModalCadastroTipoAto from "../cadastroTipoAto/ModalCadastroTipoAto";
import { printToast, summaryExclusaoSucessoPadrao, detailExclusaoSucessoPadrao } from "../../config/global";

// service
import { pesquisarAllTipoAto as pesquisarAllTipoAto, remover as removerCadastroTipoAto, salvar as salvarCadastroTipoAto, buscarAtivos as buscarAtivos, buscarPeloCodigo as buscarPeloCodigo, buscaPersonalizada as filtrarTipoAto } from "../../service/cadastroTipoAto";

const Index = () => {
  const formFiltro = {
    descTipoAto: "",
    siglTipoAto: "",
  };

  // dados pagina
  const [dataTipoAto, setDataTipoAto] = useState([]);
  const [listaTipoAto, setListaTipoAto] = useState([]);
  const [data, setData] = useState(formFiltro);
  const [totalElements, setTotalElements] = useState();

  // formulario
  const [form, setForm] = useState(null);

  // estado do modal
  const [showForm, setShowForm] = useState(false);

  // edit
  const [edit, setEdit] = useState(false);

  // campos da tabela
  const camposTabela = [
    { titulo: "Descrição", nome: "descTipoAto" },
    { titulo: "Sigla", nome: "siglTipoAto" },
  ];

  useEffect(() => {
    let filtroPage = `page=0`;
    let filtroSize = "size=10 ";
    let paginacao = `${filtroPage}&${filtroSize}`;
    pesquisarAllTipoAto(paginacao).then((res) => {
      setDataTipoAto(res.content);
    });

    // pesquisarAllTipoAto().then((res3) => {
    //   setListaTipoAto(res3);
    // });
  }, []);

  function onAdicionarDado() {
    setForm(null);
    setEdit(false);
    setShowForm(true);
  }

  function onEditarDado(rowData) {
    rowData.esferaGoverno = rowData.siglEsferaGoverno;

    setForm(rowData);
    setShowForm(true);
    setEdit(true);
  }

  const onFiltrarTipoAto = async () => {
    let filtroPage = `page=0`;
    let filtroSize = "size=10 ";
    let paginacao = `${filtroPage}&${filtroSize}`;

    let rowData = `descTipoAto=${data.descTipoAto}&siglTipoAto=${data.siglTipoAto}`;

    if (rowData) {
      await filtrarTipoAto(rowData).then((res) => {
        setDataTipoAto(res.content);
      });
    } else {

      pesquisarAllTipoAto(paginacao).then((res) => {
        setDataTipoAto(res.content);
      });
    }
  };

  function onExcluirDado(rowData) {
    removerCadastroTipoAto(rowData).then(() => {
      setTimeout(() => {
        pesquisarAllTipoAto().then((res) => {
          setDataTipoAto(res.content);
          printToast({ summary: summaryExclusaoSucessoPadrao, detail: detailExclusaoSucessoPadrao });
        });
      });
    });
  }

  //   const handleClear = () => {
  //     pesquisarAllTipoAto().then((res) => {
  //       setDataTipoAto(res.content);
  //     });
  //     setData(formFiltro);
  //   };

  return (
    <CardSeplag title="Lista de Tipos de Atos">
      <form onSubmit={onFiltrarTipoAto} className="p-col-12">
      <div className="p-grid p-col-12 p-md-12 p-sm-12">
        <RotuloSeplag nome="Descrição do Tipo do Ato:" cols="12 4">
          <InputText style={{ width: "100%" }} id="descTipoAto" value={data?.descTipoAto} onChange={(e) => setData({ ...data, descTipoAto: e.target.value })} placeholder="Acórdão, Decreto..." />
        </RotuloSeplag>
        <RotuloSeplag nome="Sigla do Tipo do Ato:" cols="12 4">
          <InputText id="siglTipoAto" style={{ width: "100%" }} name="siglTipoAto" value={data?.siglTipoAto} onChange={(e) => setData({ ...data, siglTipoAto: e.target.value })} />
        </RotuloSeplag>

        <div className="p-col-12 p-md-4" style={{ marginTop: "24px", alignContent: "center" }}>
          <Button onClick={onFiltrarTipoAto} icon="pi pi-search" label="Pesquisar" className="p-col" />
        </div>
      </div>
      </form>

      <TableSeplag totalRecords={totalElements} hasEventoAcao camposTabela={camposTabela} dados={dataTipoAto} onAdicionarDado={onAdicionarDado} onEditarDado={(rowData) => onEditarDado(rowData)} onExcluirDado={(rowData) => onExcluirDado(rowData)} />
      {showForm && <ModalCadastroTipoAto onSalvar={onFiltrarTipoAto} formEdit={form} showForm={showForm} setShowForm={setShowForm} edit={edit} />}
    </CardSeplag>
  );
};

export default Index;
